import { Pagination, Sort, FileRef, Offer, Language } from '@shared/data';

import { CbDataTableOptions, CbDataTableColumnType } from './../../cb-data-table';

export class OfferListDataTableOptions implements CbDataTableOptions<Offer> {
  sort = new Sort();
  // pagination = new Pagination();
  noResult = "common.noResult";
  header = true;
  columns = [
    {
      type: CbDataTableColumnType.IMAGE_CIRCLE,
      label: 'offer.icon',
      value: (o: Offer) => {
        return o.getIcon(Language.DEFAULT_LANG) ? o.getIcon(Language.DEFAULT_LANG).url : '/assets/img/upload.png';
      },
      bgColor: (o: Offer) => {
        return '#0b4a8e';
      }
    },
    {
      type: CbDataTableColumnType.TEXT,
      sortKey: Offer.SORT_ORDER_KEY,
      label: 'offer.sortOrder',
      value: (o: Offer) => {
        return o.sortOrder;
      }
    },
    {
      type: CbDataTableColumnType.TEXT,
      sortKey: Offer.TITLE_KEY,
      label: 'offer.title',
      value: (o: Offer) => {
        return o.getTitle(Language.DEFAULT_LANG);
      }
    },
    {
      type: CbDataTableColumnType.TEXT,
      label: 'offer.description',
      value: (o: Offer) => {
        return o.getDescription(Language.DEFAULT_LANG);
      }
    }
  ];

  editable(o: Offer): boolean {
    return false;
  };

  deletable(o: Offer): boolean {
    return true;
  };
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+offer/offer-list/offer-list.data-table-option.ts